export const privacyEn = {
  privacy: {
    page_title: "Privacy Policy",
    title: "Privacy Policy",
    last_updated: "Last updated",

    introduction: {
      title: "Introduction",
      content: "ID Network ('we', 'us', or 'our') is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our booking and studio management platform. This policy complies with the EU General Data Protection Regulation (GDPR) and other applicable data protection laws."
    },

    data_controller: {
      title: "Data Controller",
      content: "The data controller responsible for your personal data is:",
      company_name: "Company",
      email: "Email"
    },

    data_collection: {
      title: "Information We Collect",
      intro: "We collect the following types of information:",
      personal_info: "Personal identification information (name, email address, phone number)",
      contact_info: "Contact details for your studio or business",
      business_info: "Business information (studio name, address, services offered)",
      booking_info: "Booking and calendar data",
      usage_data: "Usage data and analytics"
    },

    data_purpose: {
      title: "Purpose of Data Processing",
      intro: "We use your data for the following purposes:",
      service_provision: "Providing and maintaining our booking management service",
      booking_management: "Managing bookings, appointments, and schedules",
      calendar_sync: "Synchronizing with Google Calendar (with your explicit consent)",
      communication: "Communicating with you about your bookings and account",
      analytics: "Improving our services through analytics",
      legal_compliance: "Complying with legal obligations"
    },

    google_calendar: {
      title: "Google Calendar Integration",
      content: "If you choose to connect your Google Calendar, we will:",
      read_events: "Read your calendar events to prevent double bookings",
      write_events: "Create and update calendar events for confirmed bookings",
      sync_status: "Synchronize booking status changes with your calendar",
      user_control: "You can revoke calendar access at any time through your account settings or Google account permissions. We only access calendar data necessary for booking management and never share your calendar information with third parties."
    },

    legal_basis: {
      title: "Legal Basis for Processing (GDPR)",
      consent: {
        title: "Consent",
        content: "For Google Calendar integration and marketing communications"
      },
      contract: {
        title: "Contract Performance",
        content: "To provide booking management services"
      },
      legitimate: {
        title: "Legitimate Interests",
        content: "For service improvement and analytics"
      }
    },

    data_sharing: {
      title: "Data Sharing and Disclosure",
      intro: "We do not sell your personal data. We may share your information with:",
      service_providers: "Service providers who assist in operating our platform (hosting, analytics)",
      google: "Google (only for Calendar synchronization, with your consent)",
      legal_requirements: "Legal authorities when required by law"
    },

    data_retention: {
      title: "Data Retention",
      content: "We retain your personal data only for as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required by law. Booking history is retained for 3 years for business records. You can request deletion of your account and data at any time."
    },

    user_rights: {
      title: "Your Rights Under GDPR",
      intro: "You have the following rights regarding your personal data:",
      access: {
        title: "Right to Access",
        content: "Request a copy of your personal data"
      },
      rectification: {
        title: "Right to Rectification",
        content: "Correct inaccurate or incomplete data"
      },
      erasure: {
        title: "Right to Erasure",
        content: "Request deletion of your personal data"
      },
      restriction: {
        title: "Right to Restriction",
        content: "Restrict processing of your data"
      },
      portability: {
        title: "Right to Data Portability",
        content: "Receive your data in a structured format"
      },
      objection: {
        title: "Right to Object",
        content: "Object to processing based on legitimate interests"
      },
      withdraw: {
        title: "Right to Withdraw Consent",
        content: "Withdraw consent for data processing at any time"
      },
      contact: "To exercise these rights, please contact us at"
    },

    data_security: {
      title: "Data Security",
      content: "We implement appropriate technical and organizational security measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. This includes encryption, secure servers, and regular security assessments."
    },

    cookies: {
      title: "Cookies and Tracking",
      content: "We use essential cookies to maintain your session and preferences. We use analytics cookies to understand how you use our service. You can control cookie preferences through your browser settings."
    },

    international_transfers: {
      title: "International Data Transfers",
      content: "Your data is primarily stored within the European Union. If data is transferred outside the EU, we ensure appropriate safeguards are in place, such as Standard Contractual Clauses approved by the European Commission."
    },

    children: {
      title: "Children's Privacy",
      content: "Our service is not intended for individuals under 16 years of age. We do not knowingly collect personal data from children."
    },

    changes: {
      title: "Changes to This Privacy Policy",
      content: "We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page and updating the 'Last updated' date."
    },

    contact: {
      title: "Contact Us",
      content: "If you have questions about this Privacy Policy or wish to exercise your rights, please contact us:"
    },

    supervisory: {
      title: "Supervisory Authority",
      content: "You have the right to lodge a complaint with a supervisory authority, in particular in the EU member state of your residence, if you believe our processing of your personal data violates the GDPR."
    }
  }
};
